
import { Data as MarketContent } from './market/index'
import { Data as AccountContent } from './account/index'
import { Data as IntroduceContent } from './introduce/index'
import { Data as OtherContent } from '../../listenKey/index'
let aaa = JSON.stringify(OtherContent).replaceAll("/market/","/swap-market?")
 aaa = aaa.replaceAll("/market","/swap-market")
 aaa = aaa.replaceAll("open-api-ws.bingx.com","open-api-swap.bingx.com")
 aaa = aaa.replaceAll("/swap-market?<listenKey>","/swap-market?listenKey=")
 aaa = aaa.replaceAll("wss://open-api-swap.bingx.com/swap-market?listenKey=","wss://open-api-swap.bingx.com/swap-market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")
const Other = {
    "path": "listenKey.html",
    "name": "Listen Key",
    "content": JSON.parse(aaa)
  }
const Market = {
    "path": "market.html",
    "name": "Websocket Market Data",
    "content": MarketContent
}
const Account = {
    "path": "account.html",
    "name": "Websocket Account Data",
    "content": AccountContent
}
const introduce = {
    "path": "",
    "name": "Introduction",
    "content": IntroduceContent
}

const list_temp = [
    introduce,
    Other,
    Market,
    Account
]
export const List = list_temp



// WEBPACK FOOTER //
// ./src/config/en-US/swapV2/websocket/index.js